import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/ninxl/enterprise/page.tsx");
